/* Original opening, then a confined symbol formation. Links remain the fallback. */
(() => {
  const reduced = window.nanaMotion || matchMedia('(prefers-reduced-motion: reduce)');
  const es = document.documentElement.lang === 'es';
  const gs = window.gsap;
  const story = document.querySelector('.nx-brand-story');
  let homeCleanup = () => {};

  function destinationArrival(target) {
    // Static, exact artwork is the default when motion or browser APIs are absent.
    if (!target.animate || !window.IntersectionObserver) return () => {};
    const pearls = target.querySelector('.nx-arrival-pearls');
    const symbol = target.querySelector('.nx-arrival-symbol');
    const complete = target.querySelector('.nx-arrival-complete');
    const traces = [...target.querySelectorAll('.nx-arrival-trace')];
    if (!pearls || !symbol || !complete || !traces.length) return () => {};
    let animations = [], observer, started = false, disposed = false;
    const finish = () => {
      // Removing the mask restores every pixel of the supplied final outline.
      target.dataset.arrivalState = 'complete';
      animations.forEach(animation => animation.cancel());
      animations = [];
      observer?.disconnect();
    };
    const play = () => {
      if (started || disposed) return;
      started = true;
      observer?.disconnect();
      target.dataset.arrivalState = 'running';
      const animate = (element, frames, options) => {
        const animation = element.animate(frames, {...options, fill:'both'});
        animations.push(animation);
        return animation;
      };
      try {
        animate(pearls, [{opacity:0}, {opacity:1}], {duration:250, easing:'cubic-bezier(.22,1,.36,1)'});
        traces.forEach(trace => animate(trace, [{strokeDashoffset:1}, {strokeDashoffset:0}],
          {delay:250, duration:650, easing:'cubic-bezier(.45,0,.2,1)'}));
        animate(complete, [{opacity:0}, {opacity:1}], {delay:780, duration:120, easing:'ease-out'});
        // A two-percent settle is entirely inside the reserved badge, with no x/y travel.
        const settling = animate(symbol, [{transform:'scale(.98)', opacity:.92}, {transform:'scale(1)', opacity:1}],
          {delay:900, duration:200, easing:'cubic-bezier(.22,1,.36,1)'});
        settling.finished.then(() => {if (!disposed) finish();}, () => {});
      } catch { finish(); }
    };
    target.dataset.arrivalState = 'pending';
    observer = new IntersectionObserver(entries => {
      if (disposed) return;
      for (const entry of entries) {
        // Scaled preview iframes can round a fully visible SVG below 1.0.
        if (entry.isIntersecting && entry.intersectionRatio >= .95) play();
        else if (entry.boundingClientRect.bottom < 0) { started = true; finish(); }
      }
    }, {threshold:.95, rootMargin:'0px 0px -12% 0px'});
    observer.observe(target);
    const onVisibility = () => {if (document.hidden && started) finish();};
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      disposed = true;
      finish();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }

  function initHome() {
    homeCleanup();
    if (!story || !gs || !window.ScrollTrigger || reduced.matches) return;
    gs.registerPlugin(ScrollTrigger);
    const signature = story.querySelector('.nx-signature');
    const target = document.querySelector('.nx-center-logo');
    if (!signature || !target) return;
    document.documentElement.classList.add('nx-intro-enhanced');
    const cleanupArrival = destinationArrival(target);
    const ctx = gs.context(() => {
      const intro = gs.timeline({defaults:{ease:'power3.out'}})
        .from('.nx-word-u', {opacity:.5, duration:1.1}, 0)
        .from('.nx-word-n', {opacity:0, x:22, duration:1.5}, .55)
        .from('.nx-word-r', {opacity:0, x:-22, duration:1.5}, .85)
        .from('.nx-story-caption', {opacity:0, y:15, duration:1}, 1.5)
        .to('.nx-word-sheen', {opacity:1, duration:.2}, 2.05)
        .to('.nx-word-glint', {x:700, duration:2.35, ease:'power1.inOut'}, 2.05)
        .to('.nx-word-sheen', {opacity:0, duration:.2}, 4.4);
      intro.eventCallback('onComplete', () => {
        story.dataset.nanaIntro = 'complete';
        document.dispatchEvent(new CustomEvent('nana:intro-complete'));
      });
      const render=self=>{
        if (self.progress>.005) intro.progress(1);
        gs.set(signature,{autoAlpha:1-self.progress});
        // Clear the opening locally; the destination has its own bounded animation.
        gs.set('.nx-story-caption,.nx-story-index',{autoAlpha:Math.max(0,1-scrollY/24)});
        // Keep the actions focusable while the scroll transition clears them.
        gs.set('.nx-story-scroll',{opacity:Math.max(0,1-scrollY/24)});
      };
      ScrollTrigger.create({trigger:story,start:0,end:()=>Math.min(160,story.offsetHeight*.22),invalidateOnRefresh:true,onUpdate:render,onRefresh:render});
      const settle = () => { if (document.hidden) intro.progress(1); };
      document.addEventListener('visibilitychange',settle);
      homeCleanup = () => { cleanupArrival();document.removeEventListener('visibilitychange',settle);ctx.revert();document.documentElement.classList.remove('nx-intro-enhanced'); };
    });
    document.fonts?.ready.then(()=>ScrollTrigger.refresh());
  }
  initHome();
  reduced.addEventListener('change',initHome);
  addEventListener('pagehide',()=>homeCleanup());
  addEventListener('pageshow',event=>{ if(event.persisted) initHome(); });

  if (story) story.querySelector('.nx-story-scroll')?.addEventListener('click',event=>{
    if (reduced.matches || event.detail===0) return;
    event.preventDefault();
    document.getElementById('nx-main').scrollIntoView({behavior:'smooth',block:'start'});
  });
  // Supported browsers share the original images across ordinary document navigation.
  // Older browsers get one short departure, then a normal link navigation.
  document.querySelectorAll('[data-portal]').forEach(portal=>portal.addEventListener('click',event=>{
    if (!gs || reduced.matches || event.defaultPrevented || event.detail===0 || event.button!==0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || 'onpageswap' in window) return;
    event.preventDefault();
    if (portal.classList.contains('is-departing')) return;
    portal.classList.add('is-departing');
    const leave=gs.timeline({onComplete:()=>location.assign(portal.href)});
    leave.to(portal.querySelectorAll('.nx-portal-top,h2,.nx-portal-bottom'),{opacity:0,duration:.2},0)
      .to(portal.querySelector('.nx-product-scene,.nx-clinic-window'),{scale:1.25,y:-25,duration:.65,ease:'power2.inOut'},0);
    const reset=()=>{leave.kill();portal.classList.remove('is-departing');gs.set(portal.querySelectorAll('.nx-portal-top,h2,.nx-portal-bottom,.nx-product-scene,.nx-clinic-window'),{clearProps:'opacity,transform'});};
    addEventListener('pagehide',reset,{once:true});
  }));

  const edit=document.querySelector('.nx-edit');
  if (!edit) return;
  const viewport=edit.querySelector('.nx-edit-viewport');
  const choices=[...edit.querySelectorAll('.nx-edit-choice')];
  const sequences=new WeakMap();
  let editLifecycle=0;
  reduced.addEventListener('change',()=>{editLifecycle++;});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)editLifecycle++;});
  choices.forEach(button=>{
    button.hidden=false;
    button.addEventListener('click',async event=>{
      const card=button.closest('.nx-edit-slide');
      const item=button.dataset;
      const title=es?(item.titleEs||item.title):item.title;
      const image=card.querySelector('[data-edit-image]');
      const material=card.querySelector('[data-edit-material]');
      const sequence=(sequences.get(card)||0)+1;
      const lifecycle=editLifecycle;
      sequences.set(card,sequence);
      card.querySelectorAll('.nx-edit-choice').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      card.querySelector('[data-edit-title]').textContent=title;
      card.querySelector('[data-edit-price]').textContent=item.price;
      const stock=card.querySelector('[data-edit-stock]');
      stock.textContent=item.available==='true'?(es?'Disponible':'In stock'):(es?'Agotado':'Out of stock');
      stock.dataset.unavailable=String(item.available!=='true');
      let href=item.href;
      if(es&&/\.html$/.test(href)&&!href.endsWith('.es.html'))href=href.replace(/\.html$/,'.es.html');
      card.querySelector('[data-edit-link]').href=href;
      image.src=item.image;image.alt=title;
      if(material&&item.detail) material.src=item.detail;
      card.querySelector('[data-edit-status]').textContent=`${title}. ${item.price}. ${stock.textContent}.`;
      if (!gs) return;
      gs.killTweensOf([image,material].filter(Boolean));
      gs.set([image,material].filter(Boolean),{clearProps:'opacity,scale,translate'});
      if(reduced.matches||event.detail===0)return;
      await Promise.all([image,material].filter(Boolean).map(i=>typeof i.decode==='function'?i.decode().catch(()=>{}):Promise.resolve()));
      if(sequences.get(card)!==sequence||lifecycle!==editLifecycle||document.hidden||reduced.matches||!image.naturalWidth)return;
      gs.fromTo(image,{opacity:.4,scale:.94},{opacity:1,scale:1,duration:.5,ease:'power3.out',clearProps:'opacity,scale'});
      if(material)gs.fromTo(material,{opacity:.35,scale:.93},{opacity:.85,scale:1,duration:.65,ease:'power3.out',clearProps:'opacity,scale'});
    });
  });
  if(!window.EmblaCarousel)return;
  const carousel=EmblaCarousel(viewport,{align:'start',containScroll:'trimSnaps',loop:false,duration:32,breakpoints:{'(prefers-reduced-motion: reduce)':{duration:0}}});
  viewport.classList.add('is-enhanced');
  const controls=edit.querySelector('.nx-edit-controls');controls.hidden=false;
  const prev=edit.querySelector('[data-edit-prev]'),next=edit.querySelector('[data-edit-next]');
  const fit=()=>{const slide=carousel.slideNodes()[carousel.selectedScrollSnap()];if(slide)viewport.style.height=`${Math.ceil(slide.getBoundingClientRect().height)}px`;};
  const update=()=>{
    prev.disabled=!carousel.canScrollPrev();next.disabled=!carousel.canScrollNext();
    edit.querySelector('[data-edit-counter]').textContent=`${String(carousel.selectedScrollSnap()+1).padStart(2,'0')} / ${String(carousel.scrollSnapList().length).padStart(2,'0')}`;
    fit();
  };
  prev.addEventListener('click',e=>carousel.scrollPrev(reduced.matches||e.detail===0));
  next.addEventListener('click',e=>carousel.scrollNext(reduced.matches||e.detail===0));
  carousel.on('select',update).on('reInit',update);update();
  if('ResizeObserver' in window){const sizes=new ResizeObserver(fit);carousel.slideNodes().forEach(slide=>sizes.observe(slide));}
  // Pause decorative image tweens as soon as motion is reduced or the page hides.
  const settleEdit=()=>{if(gs&&(reduced.matches||document.hidden)){const imgs=[...edit.querySelectorAll('[data-edit-image],[data-edit-material]')];gs.killTweensOf(imgs);gs.set(imgs,{clearProps:'opacity,scale,translate'});}};
  reduced.addEventListener('change',settleEdit);document.addEventListener('visibilitychange',settleEdit);
})();
